// ** UseJWT import to get config
import atlasApi from '..'

/**
* update contact
* @param {Object} data - invoicing_data : {company: {
          corporate_name: data.corporate_name,
          fantasy_name: data.fantasy_name,
          state_registration: data.state_registration,
          cnpj: data.cnpj
        },
        address: {
          street: data.street,
          number: data.number,
          complement: data.complement,
          province: data.province,
          city: data.city,
          state: data.state,
          postal_code: data.postal_code
        },
        contact: {
          phone: data.phone,
          invoice_email: data.invoice_email
        }
        order_id: id
      }
* @param {String} data.email - user email
*  @param {Object} data.airtableData - da
* @returns {Promise} - axios promise
*/

const updateContact = async (data) => {
  const { email, name, ...airtableData } = data

  return atlasApi.put('/auth/users/contact', {
    airtable_data: airtableData,
    email,
    name
  })
}

export { updateContact }
